<template>
  <div :class="boxClass">
    <!-- 工具按钮 -->
    <div class="j-vxe-tool-button div" :size="btnSize">
      <slot v-if="showPrefix" name="toolbarPrefix" :size="btnSize" />
      <!-- 新增 -->
      <mtc-button v-if="showAdd" icon="plus" @click="trigger('add')" :disabled="disabled" type="primary" text="button.add" />
      <!-- 自定义按钮 -->
      <template v-if="cgButtonList && cgButtonList.length">
        <template v-for="item in cgButtonList">
          <a-button :key="item.id" type="primary" :icon="item.buttonIcon" @click="customerButtonClick(item)">
            {{ item.buttonName }}
          </a-button>
        </template>
      </template>
      <!-- 保存 -->
      <mtc-button v-if="showSave" icon="save" @click="trigger('save')" :disabled="disabled" text="button.save" />
      <template v-if="selectedRowIds.length">
        <!-- 删除 -->
        <a-popconfirm v-if="showRemove"
                      :title="$t('tip.areYouSureDeleteItem', { num: selectedRowIds.length})"
                      @confirm="trigger('remove')">
          <mtc-button icon="minus" :disabled="disabled" text="button.delete" />
        </a-popconfirm>
        <template v-if="showClearSelection">
          <!-- 清空选择 -->
          <mtc-button icon="delete" @click="trigger('clearSelection')" text="button.clearSelection" />
        </template>
      </template>
      <slot v-if="showSuffix" name="toolbarSuffix" :size="btnSize" />
      <a v-if="showCollapse" @click="toggleCollapse" style="margin-left: 4px">
        <mtcLangPopover :text="collapsed? 'tip.down': 'tip.up'" />
        <a-icon :type="collapsed ? 'down' : 'up'" />
      </a>
      <!-- 导入 -->
      <a-upload style="display: none"
                :name="uploadParams.name"
                :showUploadList="false"
                :multiple="uploadParams.multiple"
                :accept="uploadParams.accept"
                :headers="tokenHeader"
                :action="uploadParams.url"
                @change="handleImport">
        <a-button type="primary" id="subImportButton" icon="import">明细导入</a-button>
      </a-upload>
    </div>
  </div>
</template>

<script>
import { deleteAction, getAction, postAction } from '@api/manage'
import { ACCESS_TOKEN, TENANT_ID } from '@/store/mutation-types'

export default {
  name: 'JVxeToolbar',
  inject: ['getUtilEnhanceJS'],
  props: {
    // 自定义按钮和js增强信息
    customButton: {
      type: Object,
      required: false,
      default: () => null
    },
    toolbarConfig: Object,
    excludeCode: Array,
    size: String,
    disabled: Boolean,
    disabledRows: Object,
    selectedRowIds: Array
  },
  data() {
    return {
      tokenHeader: {
        'X-Access-Token': this.$ls.get(ACCESS_TOKEN),
        'tenant-id': this.$ls.get(TENANT_ID)
      },
      // 当前操作的按钮code
      buttonCode: {},
      // 上传组件参数
      uploadParams: {
        name: 'file',
        multiple: false,
        accept: '.xls,.xlsx',
        url: '',
      },
      // 是否收起
      collapsed: true,
      // 自定义工具栏按钮
      cgButtonList: [],
      // 按钮自定义js
      EnhanceJS: {},
    }
  },
  computed: {
    // 全局公用JS增强方法
    utilEnhanceJS() {
      return this.getUtilEnhanceJS()
    },
    boxClass() {
      return {
        'j-vxe-toolbar': true,
        'j-vxe-toolbar-collapsed': this.collapsed
      }
    },
    btns() {
      let arr = this.toolbarConfig.btn || ['add', 'remove', 'clearSelection']
      let exclude = [...this.excludeCode]
      // TODO 需要将remove替换batch_delete
      // 系统默认的批量删除编码配置为 batch_delete 此处需要转化一下
      if (exclude.indexOf('batch_delete') >= 0) {
        exclude.push('remove')
      }
      // 按钮权限 需要去掉不被授权的按钮
      return arr.filter(item => {
        return exclude.indexOf(item) < 0
      })
    },
    slots() {
      return this.toolbarConfig.slot || ['prefix', 'suffix']
    },
    showPrefix() {
      return this.slots.includes('prefix')
    },
    showSuffix() {
      return this.slots.includes('suffix')
    },
    showAdd() {
      return this.btns.includes('add')
    },
    showSave() {
      return this.btns.includes('save')
    },
    showRemove() {
      return this.btns.includes('remove')
    },
    showClearSelection() {
      if (this.btns.includes('clearSelection')) {
        // 有禁用行时才显示清空选择按钮
        // 因为禁用行会阻止选择行，导致无法取消全选
        let length = Object.keys(this.disabledRows).length
        return length > 0
      }
      return false
    },
    showCollapse() {
      return this.btns.includes('collapse')
    },
    btnSize() {
      return this.size === 'tiny'? 'small': null
    }
  },
  created() {
    if (this.customButton) {
      this.initCgButtonList(this.customButton.cgButtonList)
      this.initCgEnhanceJs(this.customButton.enhanceJs)
    }
  },
  methods: {
    // 初始化自定义按钮
    initCgButtonList(btnList) {
      let buttonArr = []
      if (btnList && btnList.length > 0) {
        for (let i = 0; i < btnList.length; i++) {
          let temp = btnList[ i ]
          if (temp.buttonStyle === 'button') {
            buttonArr.push(temp)
          }
        }
      }
      this.cgButtonList = [...buttonArr]
    },
    // 初始化JS增强方法
    initCgEnhanceJs(enhanceJs) {
      if (!enhanceJs) return
      let Obj = eval('(' + enhanceJs + ')')
      this.EnhanceJS = new Obj(getAction, postAction, deleteAction)
    },
    // 自定义按钮点击触发事件
    customerButtonClick(buttonItem) {
      this.buttonCode = buttonItem
      if(buttonItem.optType === 'import') return this.initImport(buttonItem.buttonCode)
      this.customerButtonSubmit({ button: buttonItem })
    },
    // 初始化上传参数
    initImport(buttonCode) {
      let importParams = this.cgButtonJsHandler(buttonCode)
      if(!importParams) return this.$message.warning('请设置上传参数')
      importParams.url = window._CONFIG.domianURL + importParams.url
      this.uploadParams = Object.assign(this.uploadParams, importParams)
      let dom = document.getElementById('subImportButton')
      dom.click()
    },
    // 文件上传
    handleImport(e) {
      let { file } = e
      if(file.status === 'done') {
        let res = file.response
        if(res.code !== 200) return this.$message.warning(res.message)
        this.customerButtonSubmit({
          button: this.buttonCode,
          detailData: res.result
        })
      }
    },
    // 自定义按钮提交到父组件方法
    customerButtonSubmit(detailData) {
      this.$emit('customerButtonClick', detailData)
    },
    // JS增强类型自定义按钮里的方法
    cgButtonJsHandler(buttonCode) {
      if (this.EnhanceJS[ buttonCode ]) return this.EnhanceJS[ buttonCode ](this)
    },
    // 处理自定义button的 需要配置该button自定义sql
    cgButtonActionHandler(buttonCode) {
      if (!this.selectedRowIds || !this.selectedRowIds.length) {
        this.$message.warning(this.$t('tip.pleaseSelectARecord'))
        return false
      }
      if (this.selectedRowIds.length > 1) {
        this.$message.warning(this.$t('tip.pleaseSelectARecord'))
        return false
      }
      let params = {
        formId: this.code,
        buttonCode: buttonCode,
        dataId: this.selectedRowIds[ 0 ]
      }
      postAction(this.url.buttonAction, params).then(res => {
        this.$message.success(res.message)
      })
    },
    /** 触发事件 */
    trigger(name) {
      this.$emit(name)
    },
    // 切换展开收起
    toggleCollapse() {
      this.collapsed = !this.collapsed
    }
  }
}
</script>

<style lang="less">
.j-vxe-toolbar-collapsed {
  [data-collapse] {
    display: none;
  }
}

.j-vxe-tool-button.div .ant-btn {
  margin-right: 8px;
}
</style>